'use strict';

module.exports = function prepend(value, key) {
  if (key !== undefined) {
    return this.put(key, value);
  }

  this.items.unshift(value);
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/prepend.js
// module id = 1697
// module chunks = 2